const listShopEN = {
	title: "List Your Shop",
	subtitle: "Get bookings online",
	shopName: "Shop name",
	ownerName: "Owner name",
	email: "Email",
	phone: "Phone",
	shopDescription: "Short description of your shop",
	registerShop: "Register Shop",
	alreadyHaveAccount: "Already have an account?",
	signIn: "Sign in",
	sending: "Sending...",
	perkFreeTitle: "14-day free trial",
	perkFreeDesc: "No credit card required",
	perk1Title: "Set up in 15 minutes",
	perk1Desc: "No technical knowledge needed",
	perk2Title: "Automated reminders",
	perk2Desc: "Reduce no-shows by up to 40%",
	perk3Title: "Referral program",
	perk3Desc: "Invite a business, both get a free month",
	referralCode: "Referral code (optional)",
	referralCodePlaceholder: "e.g. ABC123",
	requestCategory: "Can't find your business type? Request it",
	requestCategoryModal: {
		title: "Request a category",
		subtitle: "Sin Fila reviews all category requests. If approved, you'll be able to update it from your account.",
		suggestionPlaceholder: "Your business type (e.g. Yoga studio)",
		emailPlaceholder: "Your email (optional)",
		cancel: "Cancel",
		send: "Save",
		sending: "Saving...",
		success: "Request sent. Thank you!",
		error: "Failed to send request.",
		fillRequired: "Please describe your business type.",
		invalidEmail: "Please enter a valid email address.",
	},
};

export default listShopEN;